import { render, staticRenderFns } from "./BorderPalette.vue?vue&type=template&id=0450eae8&scoped=true&"
import script from "./BorderPalette.vue?vue&type=script&lang=js&"
export * from "./BorderPalette.vue?vue&type=script&lang=js&"
import style0 from "./BorderPalette.vue?vue&type=style&index=0&id=0450eae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0450eae8",
  null
  
)

export default component.exports